import React from "react";
import MuiButton from "@mui/material/Button";
import LinearProgress from "@mui/material/LinearProgress";
import sxStyles from "./Button.style";
const Button = ({ className, color = "primary", variant = "contained", isLoading = false, fullWidth = false, disabled = false, children, ...others }) => {
    return (React.createElement(MuiButton, { className: className, sx: () => sxStyles(fullWidth).buttonWrapper, color: color, variant: variant, fullWidth: fullWidth, disabled: isLoading || disabled, ...others },
        children,
        isLoading && React.createElement(LinearProgress, { sx: sxStyles().loader, color: color === "secondary" ? color : "primary" })));
};
export default Button;
//# sourceMappingURL=Button.js.map